<template>
<div style="padding: 15px;height: calc(100vh - 170px); overflow: scroll; text-align: center;" class="Kanit">
  <!-- testeiei -->
  <h3>ความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล<br/>สำหรับลูกค้าของ บริษัท วัน เซ็นทริค จำกัด</h3>
  <div style="text-align: left; margin-top: 10px;">
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; บริษัท วัน เซ็นทริค จำกัด ได้พัฒนา Platform OneChat เป็นแอปพลิเคชันสำหรับการติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ใช้เป็นเครื่องมือในการทำธุรกรรมตัวตนดิจิตอลที่น่าเชื่อถือ รองรับการยืนยันตัวตนแบบ e-KYC และสามารถรองรับการลงลายมือชื่ออิเล็กทรอนิกส์โดยใช้ใบรับรองอิเล็กทรอนิกส์ (Certificate) ที่ระบุตัวตน หรือองค์กรผู้เป็นเจ้าของลายมือชื่อ เพื่อแสดงว่าบุคคล หรือองค์กรดังกล่าวยอมรับข้อความในข้อมูลอิเล็กทรอนิกส์นั้นได้ และขณะเดียวกัน บริษัท วัน เซ็นทริค จำกัด ให้ความสำคัญต่อความเป็นส่วนตัว เราจะทำงานอย่างดีที่สุดเพื่อรักษาความลับ และควบคุมข้อมูลส่วนบุคคลของคุณให้ปลอดภัย โดยที่คุณสามารถเลือกที่จะให้หรือไม่ให้ความยินยอมก็ได้
    </span>
  </div>
  <div v-if="show" style="text-align: left;margin-top: 10px;">
    <h4>1. วัตถุประสงค์ในการเก็บรวบรวม/ใช้/เปิดเผย ข้อมูลส่วนบุคคล</h4>
    <div class="consentbordersite">
      <h4>ความยินยอมเป็นฐานข้อมูลในการวิจัยหรือจัดทำสถิติ การปรับปรุงคุณภาพของการให้บริการของบริษัทฯ <span style="color: #8b8b8b !important; margin-bottom: 0px; font-weight: 500;">(จำเป็น)</span></h4>
      <span>เพื่อให้คุณใช้งานได้สะดวก ตรงใจมากขึ้น เราอาจเก็บข้อมูลของท่านและนำมาวิเคราะห์และปรับปรุงบริการของเรา รวมไปถึงการอำนวยความสะดวก เพื่อให้ประสบการณ์ใช้งานที่รวดเร็ว ตอบสนองต่อความต้องการและพึงพอใจของผู้ใช้ คุณยินยอมให้ บริษัท วัน เซ็นทริค จำกัด เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อจุดประสงค์ที่กล่าวมาข้างต้น</span>
      <hr class="underline_consent"/>
      <div>
        <v-radio-group v-model="consent_1" hide-details row>
          <v-radio  label="ยินยอม" value="true" color="#2562af" style="width: 33vw;"></v-radio>
          <v-radio  label="ไม่ยินยอม" value="false" color="#2562af" style="width: 33vw;"></v-radio>
        </v-radio-group>
      </div>
    </div>

    <div class="consentbordersite" >
      <h4>ความยินยอมในการติดต่อกลับสำหรับแนะนำผลิตภัณฑ์ และนำเสนอบริการต่าง ๆ ของบริษัทฯเพิ่มเติมตามที่ท่านทำการร้องขอ หรือบริการอื่น ๆ ที่เกี่ยวข้อง)</h4>
      <span>เพื่อให้คุณได้รับข้อเสนอ โปรโมชั่น เนื้อหา สินค้า หรือ บริการที่คัดสรรมาสำหรับคุณโดยเฉพาะ และตอบโจทย์คุณมากยิ่งขึ้น คุณยินยอมให้ บริษัท วัน เซ็นทริค จำกัด เก็บรวมรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อจุดประสงค์ที่กล่าวมาข้างต้น</span> <br/>
      <span class="linkpolicy" @click="showpolicy=true">นโยบายคุ้มครองความเป็นส่วนตัว ของบริษัท วัน เซ็นทริค จำกัด</span>
      <hr class="underline_consent"/>
      <div>
        <v-radio-group v-model="consent_2" hide-details row>
          <v-radio  label="ยินยอม" value="true" color="#2562af" style="width: 33vw;"></v-radio>
          <v-radio  label="ไม่ยินยอม" value="false" color="#2562af" style="width: 33vw;"></v-radio>
        </v-radio-group>
      </div>
    </div>
     <h4 style="margin-top: 10px;">2. ข้อมูลที่เจ้าของข้อมูลให้ไว้ตามวัตถุประสงค์ในข้อ 1 ได้แก่</h4>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ข้อมูลส่วนตัว ได้แก่ ชื่อ-นามสกุล, เบอร์โทรศัพท์</span>
     <h4 style="margin-top: 10px;">3. สิทธิของเจ้าของข้อมูล</h4>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.1 สิทธิในการเพิกถอนความยินยอมให้บริษัทฯประมวลผลข้อมูลส่วนบุคคลของท่าน</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.2 สิทธิในการเข้าถึงและรับสำเนาข้อมูลส่วนบุคคลที่บริษัทฯได้เก็บรวบรวม ใช้ เปิดเผย</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.3 สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคลของท่าน</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.4 สิทธิในการคัดค้าน การประมวลผลข้อมูลส่วนบุคคลของท่าน</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.5 สิทธิในการขอให้ลบ ทำลาย หรือทำให้ข้อมูลส่วนบุคคลของท่านซึ่งไม่อาจระบุตัวตนได้</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.6 สิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่าน</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.7 สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้องเป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.8 สิทธิที่จะร้องเรียนในกรณีที่ท่านเห็นว่าถูกบริษัทฯฯ หรือเจ้าหน้าที่หรือตัวแทนของบริษัทฯฯ ละเมิดสิทธิตาม พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</span><br/>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.9 ท่านสามารถแจ้งความประสงค์การดำเนินการตามข้อ 3.1 ถึงข้อ 3.8 ได้ โดยแจ้งมายัง  <a href="mailto:noc@inet.co.th">noc@inet.co.th</a> หรือ Call center <a href="tel:022577000">02-257-7000</a>, <a href="tel:022577111">02-257-7111</a></span>
     <h4 style="margin-top: 10px;">4. ระยะเวลาการเก็บข้อมูล</h4>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; บริษัทฯจะจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน และข้อมูลอื่น ๆ เป็นระยะเวลา 1 ปี หรือตามสัญญาหลักที่ทำกับบริษัทฯ หรือจนกว่าท่านจะยกเลิกการให้ความยินยอม</span>
     <h4 style="margin-top: 10px;">5. ช่องทางการติดต่อ</h4>
     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310 </span><br/>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Email : <a href="mailto:noc@inet.co.th">noc@inet.co.th</a> </span><br/>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; •  โทร <a href="tel:022577000">02-257-7000</a>, <a href="tel:022577111">02-257-7111</a><br/>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ข้าพเจ้าตกลงยินยอมที่จะผูกพันตนเองตามข้อกำหนดและเงื่อนไขที่ปรากฏในหนังสือขอความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลสำหรับลูกค้าของบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)</span>
</span>
  </div>

  <div v-if="!show">
    <v-btn class="detailbtn" @click="show=true">ดูรายละเอียด</v-btn>
    <v-btn class="consentbtn" @click="sendconsentALL()" :disabled="checkdisabled()">ให้ความยินยอม</v-btn>
  </div>
  <div v-else>
    <v-btn class="consentbtn" @click="sendconsent()" :disabled="consent_1 == '' || consent_2 == ''">บันทึก</v-btn>
  </div>




<v-dialog v-model="showpolicy" style="border-radius: 10px;" >
    <v-card style="border-radius: 10px;">
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text Kanit">&nbsp;&nbsp;{{$t('RightSide.header.privatepolicy')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click.native="showpolicy=false">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    <policydialog/>
    </v-card>
  </v-dialog>



</div>
</template>

<script>

import policydialog from '@/components/consent/Policy'
export default {
  data: () => ({
    show: false,
    consent_1: '',
    consent_2: '',
    consent_check: '',
    showpolicy: false
  }),
  components: {
    policydialog
  },
  created() {
    this.onechat_token = this.$route.query.onechat_token
    this.checkconsent()
    // this.checkform(this.$route.query.onechat_token)
    // this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  methods: {
    changeLan (lang) {
      this.$i18n.locale = lang
    },
    checkdisabled () {
      return this.consent_check=='true'? true:false
    },
    sendconsentALL () {
      this.consent_1 = "true"
      this.consent_2 = "true"
      this.sendconsent()
    },
    sendconsent () {
      this.axios.post(process.env.APIgo_api + '/v1/set-consent', {
        onechat_token: this.onechat_token,
        consent_status: [this.consent_1, this.consent_2],
        consent_version: "C7gi50r08q6"
      }).then((response) => {
        // console.log(response.data)
        this.checkconsent()
        // this.isSet = true
      })
    },
    checkconsent () {
      // console.log('test')
      this.axios.post(process.env.APIgo_api + '/v1/get-consent', {
        onechat_token: this.onechat_token,
        consent_version: "C7gi50r08q6"
      }).then((response) => {
        // console.log(response.data.data.consent_status)
        try {
          this.consent_check = response.data.data.consent_check
          this.consent_1 = response.data.data.consent_status[0]
          this.consent_2 = response.data.data.consent_status[1]
        } catch(err) {
          console.log(err)
        }
      })
    }

  }
}
</script>

<style type="text/css" scoped>
.Kanit {
  font-family: 'Kanit' !important;
  word-wrap: break-word;
}
.underline_consent {
  border: none !important;
    border-bottom: 1px solid #e0e0e0 !important;
    margin-bottom: 5px;
    margin-top: 5px;
}
.linkpolicy {
  color: #2562af;
  cursor: pointer;
}
.detailbtn {
  box-shadow: none !important;
  border: solid 1px #353535 !important;
}
.consentbtn {
  box-shadow: none !important;
  background: #2562af !important;
  color: white !important;
}
.consentbordersite {
  border: solid 1px #e0e0e0 !important;
    padding: 10px !important;
    border-radius: 10px !important;
    margin-top: 5px !important;
}
.rowForm {
  margin-top: 10px;
  display: table;
}
.InputEdit {
    height: 43px;
    width: calc(100vw - 50px);
    max-width: 500px;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}

>>>.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
     margin-bottom: 0px !important;
}


>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
    padding-left: 10px !important;
}
>>>.v-input--selection-controls.v-input .v-label {
    font-size: 14px !important;
    color: #202020 !important;
}
>>>.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.bginform {
    background: white;
    padding: 10px;
    border-radius: 15px;
}

  select, textarea, input {
    width: 100%;
    font-size: 16px;
  }

  select:focus, textarea:focus, input:focus {
    width: 100%;
    font-size: 16px;
  }
  input[type=text]:focus {
    width: 100%;
    font-size: 16px;
  }
  .iconLanguage {
  height: 25px;
  cursor: pointer;
  margin-top: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/consent/consent_C7gi50r08q6.vue